import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { FreemiumService } from '../freemium.service';
import { FreemiumConstants, LoaderType } from '../freemiumConstants';
import { PersonData } from '../freemiumParams';
import { WebbtreeJdSearchFilterModalComponent } from '../webbtree-jd-search-filter-modal/webbtree-jd-search-filter-modal.component';

@Component({
    selector: 'app-talentpool-report-section',
    templateUrl: './talentpool-report-section.component.html',
    styleUrls: ['./talentpool-report-section.component.scss'],
    standalone: false
})
export class TalentpoolReportSectionComponent implements OnInit {

  totalCandidatesCount: number = 0;
  subscriptions: Subscription[] = [];
  malePercent: any = null;
  femalePercent: any = null;
  changedJobs: number = 0;
  totalMedianTanureCount: number = 0;
  likelyToMoveInCountAvailable: boolean = false;
  medianTenureInCountAvailable: boolean = false;
  genderDataAvailable: boolean = false;
  changedJobsCountAvailable: boolean = false;
  filterChips: any[] = [];
  @Input() tabName: string;
  @Output() updateFilterEvent: EventEmitter<any> = new EventEmitter();
  totalCandidatesCountAvailable: boolean = false;
  showMedianLoader: Boolean = false;


  constructor(private freemiumService: FreemiumService, private ngZone: NgZone, private modalService: NgbModal) {
    this.freemiumService.getInsightsProfileSection.subscribe(res=>{
      this.filterChips = [];
      this.showFilterAndCount();
    })
   }

  ngOnInit() {
    this.showFilterAndCount();
    this.freemiumService.showInsightsTab.subscribe(res=>{
      this.showFilterAndCount();
    })

  }

  getRecommendData(data: PersonData) {
    this.totalCandidatesCount = data.totalCandidatesCount;
      this.totalCandidatesCountAvailable = false;
  }

  // not in an indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  getstatsData(res: [any, any, any]) {
    let response = res.find(el => !!el?.data?.aggregations?.gender);
    const maleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
    const femaleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
    this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;


    response = res.find(el => !!el.data.aggregations.changedjobs);
    this.changedJobs = response.data && response.data.aggregations && response.data.aggregations.changedjobs && response.data.aggregations.changedjobs.doc_count;

    response = res.find(el => !!el.data.aggregations.total_tenure_median);
    this.totalMedianTanureCount = response.data && response.data.aggregations && response.data.aggregations.total_tenure_median && response.data.aggregations.total_tenure_median.value;
    this.showMedianLoader = false;
    this.ngZone.run(() => {
      this.setCountAvailableAll();
    })
  }

  private setCountAvailableAll() {
    this.likelyToMoveInCountAvailable = true;
    this.medianTenureInCountAvailable = true;
    this.genderDataAvailable = true;
    this.changedJobsCountAvailable = true;
  }

  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (tenure == null) {
      return 0;
    } else if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
        return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }

  returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className = 'median-tenure-text-size';
    spanTag.innerHTML = text
    return spanTag;
  }

  getFreemiumFilters() {
    const filterData = this.freemiumService.fetchQuickSearchData;
    if (this.tabName == FreemiumConstants.REDIRECT_SOURCES.QUICK_SEARCH) {
      if (filterData && filterData?.jobTitleSelectedList?.length) {
        filterData.jobTitleSelectedList.forEach(jt => {
          this.filterChips.push({ field: jt?.chipkey, name: 'Job Title', isMandatory: false })
        })
      }

      if (filterData && filterData?.skillsSelectedList?.length) {
        filterData.skillsSelectedList.forEach(sk => {
          this.filterChips.push({ field: sk?.chipkey, name: 'Skills', isMandatory: false })
        })
      }

      if (filterData && filterData?.locationSelectedList?.length) {
        filterData.locationSelectedList.forEach(ls => {
          this.filterChips.push({ field: ls?.chipkey, name: 'Location', isMandatory: false })
        })
      }

      if (filterData && filterData?.companySelectedList?.length) {
        filterData.companySelectedList.forEach(ls => {
          this.filterChips.push({ field: ls?.chipkey, name: 'Company', isMandatory: false })
        })
      }
    } else {
      if (filterData.job_description_keys && filterData.job_description_keys.job_titles.length > 0) {
        filterData.job_description_keys.job_titles.forEach(jt => {
          this.filterChips.push({ field: jt, name: 'Job Title', isMandatory: false })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.degrees.length > 0) {
        filterData.job_description_keys.degrees.forEach(d => {
          this.filterChips.push({ field: d, name: 'Degree', isMandatory: false })
        })
      }

      if (filterData.job_description_keys && filterData.job_description_keys.education_majors.length > 0) {
        filterData.job_description_keys.education_majors.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Field of study', isMandatory: false })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.industries.length > 0) {
        filterData.job_description_keys.industries.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Industry', isMandatory: false })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.skills.length > 0) {
        filterData.job_description_keys.skills.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Skills', isMandatory: false })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.schools.length > 0) {
        filterData.job_description_keys.schools.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Schools', isMandatory: false })
        })
      }

      if (filterData.job_description_keys && filterData.job_description_keys.mandatory_job_titles.length > 0) {
        filterData.job_description_keys.mandatory_job_titles.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Job Title', isMandatory: true })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.locations.length > 0) {
        filterData.job_description_keys.locations.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Location', isMandatory: false })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.mandatory_locations.length > 0) {
        filterData.job_description_keys.mandatory_locations.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Location', isMandatory: true })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.mandatory_skills.length > 0) {
        filterData.job_description_keys.mandatory_skills.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Skills', isMandatory: true })
        })
      }
      if (filterData.job_description_keys && filterData.job_description_keys.mandatory_companies?.length > 0) {
        filterData.job_description_keys.mandatory_companies.forEach(ed => {
          this.filterChips.push({ field: ed, name: 'Company', isMandatory: true })
        })
      }
    }


  }

  showFilterAndCount() {
    this.filterChips = [];
    const recCandidateDataSub = this.freemiumService.recFreemiunCandidateDataEvent.subscribe(data => this.getRecommendData(data));
    this.subscriptions.push(recCandidateDataSub);

    const statsDataSub = this.freemiumService.statsFreemiumUpdateEvent.subscribe(res => this.getstatsData(res));
    this.subscriptions.push(statsDataSub);

    const loaderSub = this.freemiumService.loaderEvent.subscribe(event => this.setLoaders(event));
    this.subscriptions.push(loaderSub);

    this.getFreemiumFilters();
  }

  openFilterModal() {
    const modalRef = this.modalService.open(WebbtreeJdSearchFilterModalComponent, { size: 'lg', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.tabname = this.tabName;
    modalRef.componentInstance.type = "Edit";
    modalRef.componentInstance.updateModalFilterEvent.subscribe(res=>{
      if(res.type == "scroll"){
        modalRef.dismiss();
        this.scrollToFreeTrial(res.eventName, 'modal');

      }
    })

    modalRef.result.then(res => {
      this.filterChips = [];
    //  if(this.tabName == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION)
      this.freemiumService.changensightsProfileSection({showInsights: true, tabName: this.tabName});

      this.freemiumService.getPersonSearchRecommendForFreemium();
      this.freemiumService.getStatsAggs();
      this.showFilterAndCount();

    })
     }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());

  }

  /**
   * scroll for upgrade the trial
   */
  scrollToFreeTrial(eventName: string, type?) {
    this.updateFilterEvent.emit({ status: 'scroll', eventName: eventName, type: type });

  }

  viewmoredetails(type) {
    if (type == 'viewMore') {
      document.getElementById('modal-viewMore').style.display = 'none';
      document.getElementById('modal-viewLess').style.display = 'block';
    } else if (type == 'viewLess') {
      document.getElementById('modal-viewMore').style.display = 'block';
      document.getElementById('modal-viewLess').style.display = 'none';
    }
  }

  setLoaders(event: LoaderType) {
    if (event === LoaderType.LODER_TYPE.RECOMMENDED_CANDIDATE) {
      this.totalCandidatesCountAvailable = true;
    } else if(event === LoaderType.LODER_TYPE.STATS) {
      this.showMedianLoader = true;
    }
  }

}

